import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Switch from '@material-ui/core/Switch';
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { makeHeadData } from 'lib/commonLib';

import NewButton from 'components/molecules/NewButton';
import NewTableContainer from 'components/molecules/NewTable';
import Modal from 'components/organisms/NewModal';

const useStyles = makeStyles((theme) => ({
  deleteBtn: {
    backgroundColor: 'rgb(220 88 88 / 50%)',
    color: '#fff',
    border: 'none',
    '&:hover': { backgroundColor: theme.palette.common.red },
  },
}));

const AccountModal = (props) => {
  const { modal, handleClose, handleUserDelete } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const [deleteFlag, setDeleteFlag] = useState(false);

  const tableInfoJson = {
    menu: {
      headList: [
        {
          id: 'MENU_SEQ',
          label: 'MENU_SEQ',
          orderFlag: false,
          displayFlag: false,
        },
        {
          id: 'MENU_NM',
          label: '개별 권한',
          orderFlag: false,
          type: 'string',
          format: '@',
          displayFlag: true,
        },
      ],
      sort: 'desc',
      order: 'MENU_NM',
    },
    group: {
      headList: [
        {
          id: 'USER_GRP_NO',
          label: 'USER_GRP_NO',
          orderFlag: false,
          displayFlag: false,
        },
        {
          id: 'USER_GRP_NM',
          label: '그룹 이름',
          orderFlag: false,
          type: 'string',
          format: '@',
          displayFlag: true,
        },
      ],
      sort: 'desc',
      order: 'USER_GRP_NM',
    },
  };

  const handleDeleteFlag = () => {
    setDeleteFlag(!deleteFlag);
  };

  return (
    <Modal
      open={modal.open}
      headerTitle={modal.params.USER_NAME}
      handleClose={handleClose}
      confirmBtnOpen={false}
      cancelBtnTitle={t('확인')}
      style={{ width: 800 }}
    >
      <FormControlLabel
        control={
          <Switch
            checked={deleteFlag}
            onChange={handleDeleteFlag}
            name="checkedB"
            color="primary"
          />
        }
        label={t('계정 삭제')}
      />
      <div
        style={{
          float: 'right',
          marginBottom: 10,
        }}
      >
        <NewButton
          onClick={handleUserDelete}
          className={classes.deleteBtn}
          disableRipple
          style={{
            width: 100,
            opacity: deleteFlag ? 1 : 0,
            transition: 'all .5s',
          }}
        >
          {t('계정 삭제')}
        </NewButton>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ width: '50%' }}>
          <NewTableContainer
            params={{}}
            getParam={(f) => f}
            // params 값이 없이 사용하는 테이블
            useTotal={false}
            useSearch={false}
            useExcel={false}
            useFullScreen={false}
            title={t('그룹 권한 리스트')}
            // useToolBar={false}
            propsList={modal.data.grpList}
            propsHeadCells={makeHeadData(tableInfoJson.group.headList)}
            useCustomTable
          />
        </div>
        <div style={{ width: '50%' }}>
          <NewTableContainer
            params={{}}
            getParam={(f) => f}
            // params 값이 없이 사용하는 테이블
            useTotal={false}
            useSearch={false}
            useExcel={false}
            useFullScreen={false}
            title={t('개인 권한 리스트')}
            // useToolBar={false}
            propsList={modal.data.menuList}
            propsHeadCells={makeHeadData(tableInfoJson.menu.headList)}
            useCustomTable
          />
        </div>
      </div>
    </Modal>
  );
};

export default AccountModal;
